import { IResponse } from "models";

export enum ActionType {
  GET_CONSULTATION_DETAILS = "action/GET_CONSULTATION_DETAILS",
  GET_CONSULTATION_DETAILS_SUCCESS = "action/GET_CONSULTATION_DETAILS_SUCCESS",
  GET_CONSULTATION_DETAILS_ERROR = "action/GET_CONSULTATION_DETAILS_ERROR",
  GET_CONSULTATION_DETAILS_RESET = "action/GET_CONSULTATION_DETAILS_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface ConsultationDetailsPayload {
  id: any;
}

export interface IConsultAnswer {
  id: number;
  answer_id: number;
  answer_text: string;
  consultations_question_answer_id: number;
  answer: {
    id: number;
    question_id: number;
    title: string;
    sub_answers: any[];
    position: any;
    answer_type: any;
  };
  consultation_sub_answers: any[];
}

export interface IConsultQAItem {
  id: number;
  question_id: number;
  consultation_id: number;
  question_text: string;
  answer_text: string;
  consultation_answers: IConsultAnswer[];
  answer_images: string[];
  answer_videos: string[];
  comment: string;
  position: any;
}

export interface IConsultDetails {
  id: number;
  patient: {
    name: string;
    gender: number;
    age: number | null;
  };
  disease_name: string;
  consultation_created_at: string;
  doctor_response_created_at: string;
  diagnosis_title: string;
  diagnosis_comment: string;
  medical_instruction_title: string;
  medicines_name: string;
  medicine_comment: string;
  doctor_name: string;
  hospital_names: string;
  consultations_question_answers: IConsultQAItem[];
}

export interface IConsultationDetailsResponse extends IResponse {
  result: IConsultDetails;
}
